import { atomFamily, AtomEffect, DefaultValue } from 'recoil';
import { IDocSetting } from '@typings/posting/postingSetting.interface';

/**
 * collectionPath별 localStorage key로 page 설정을 persist.
 * - 초기화: localStorage hit → setSelf로 즉시 주입 → isLoading = false
 * - 갱신: Firestore listen:true 리스너가 감지 → atom 업데이트 → onSet 발화 → localStorage 동기화
 */
const localStorageEffect =
  (key: string): AtomEffect<IDocSetting | null> =>
  ({ setSelf, onSet }) => {
    if (typeof window === 'undefined') return;
    try {
      const saved = localStorage.getItem(key);
      if (saved) setSelf(JSON.parse(saved));
    } catch {}
    onSet((newValue) => {
      try {
        if (newValue instanceof DefaultValue || newValue === null) localStorage.removeItem(key);
        else localStorage.setItem(key, JSON.stringify(newValue));
      } catch {}
    });
  };

/**
 * 게시판 페이지 설정을 collectionPath 단위로 캐싱하는 atomFamily.
 *
 * - 페이지 최초 방문: Firestore에서 로드 후 저장 (null → 실제값)
 * - 재방문(리마운트): Recoil 인메모리 캐시로 즉시 반환
 * - 새로고침: localStorage 캐시로 즉시 반환 → 로더 없이 렌더
 * - 데이터 변경: listen:true 리스너가 감지 → atom 업데이트 → localStorage 갱신
 */
export const pageSetAtomFamily = atomFamily<IDocSetting | null, string>({
  key: 'pageSetAtomFamily',
  default: null,
  effects_UNSTABLE: (collectionPath) => [
    localStorageEffect(`pageSetting_${collectionPath}`),
  ],
});
